// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2KfhJ","errorLogs":"EditorFooter_errorLogs__1-thg"};